module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction_home_improvements.htm"
    }
  }, [_vm._v("Introduction: Home Improvements")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/1_how_to_read.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("1.")]), _vm._v("How to Read")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/2_reading_and_sociability.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("2.")]), _vm._v("Reading and Sociability")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/3_using_books.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("3.")]), _vm._v("Using Books")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/4_access_to_reading.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("4.")]), _vm._v("Access to Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/5_verse_at_home.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("5.")]), _vm._v("Verse at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/6_drama_and_recital.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("6.")]), _vm._v("Drama and Recital")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/7_fictional_worlds.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("7.")]), _vm._v("Fictional Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/8_piety_and_knowledge.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("8.")]), _vm._v("Piety and Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/afterword.htm"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0